/**
 * 위젯이 기대는 메뉴 (2026-09-16 · 대시보드 시안 v2 V6) — 시작 틀 · 새 대시보드 창이 «메뉴 꺼짐»을 가를 때 쓴다.
 *
 * ★ 위젯 안의 `useMenuGate(...)` 와 **같은 키**다. 위젯이 게이트를 바꾸면 여기도 함께 고친다.
 * ★ 여러 메뉴를 한 줄로 모으는 위젯(한눈에 · 오늘 할 일 · 이번 주 요약 · 내 프로필)은 적지 않는다 —
 *   하나가 꺼져도 나머지로 선다.
 */
export const WIDGET_MENU_KEY: Readonly<Record<string, string>> = {
  calendar: 'calendar',
  schedule: 'calendar',
  'week-timeline': 'calendar',
  notices: 'board',
  'notice-banner': 'board',
  mail: 'mail',
  tasks: 'task',
  chats: 'chat',
  'room-status': 'reservation',
  'photo-wall': 'workspace',
  'recent-docs': 'workspace',
  'team-presence': 'attendance',
};

/** 메뉴가 꺼져 담을 수 없는 위젯인가. 판정 규칙은 `useMenuEnabledFn` 과 같다(모르면 켬). */
export function widgetMenuBlocked(widgetKey: string, menuEnabled: (menuKey: string) => boolean): boolean {
  const menuKey = WIDGET_MENU_KEY[widgetKey];
  return menuKey ? !menuEnabled(menuKey) : false;
}
